// extracted by mini-css-extract-plugin
module.exports = {"audienceChannels":"AudienceChannels_audienceChannels__3LKgI","channelItem":"AudienceChannels_channelItem__C7SNz"};